import { grpcClientFactory } from '../../grpcClientFactory';
class StatisticsService {
    createAuthenticatedClient() {
        return grpcClientFactory.createAuthenticatedUserProjectsClient({ enableCompression: true });
    }
    async get(projectId) {
        const sessionId = localStorage.getItem('landscope_session_id');
        const sessionToken = localStorage.getItem('landscope_session_token');
        if (!sessionId || !sessionToken) {
            throw new Error('User must be authenticated to get project statistics');
        }
        return new Promise((resolve) => {
            try {
                const GetProjectStatisticsRequest = proto.landscope.mapviewer.v1.GetProjectStatisticsRequest;
                const grpcRequest = new GetProjectStatisticsRequest();
                grpcRequest.setProjectId(projectId);
                const authenticatedClient = this.createAuthenticatedClient();
                const metadata = { 'authorization': `Bearer ${sessionId}|${sessionToken}` };
                authenticatedClient.getProjectStatistics(grpcRequest, metadata, (err, response) => {
                    var _a, _b, _c, _d, _f, _g, _h, _j, _k, _l, _m, _o;
                    if (err || !response) {
                        resolve(null);
                        return;
                    }
                    try {
                        const toLatLng = (coord) => ({ lat: coord.getLatitude(), lng: coord.getLongitude() });
                        const propertyPolygonList = ((_a = response.getPropertyPolygonList) === null || _a === void 0 ? void 0 : _a.call(response)) || [];
                        const bufferPolygonList = ((_b = response.getBufferPolygonList) === null || _b === void 0 ? void 0 : _b.call(response)) || [];
                        const propertyPolygon = propertyPolygonList.map(toLatLng);
                        const bufferPolygon = bufferPolygonList.map(toLatLng);
                        const mapItem = (item) => {
                            var _a, _b, _c, _d, _f;
                            return ({
                                key: (_a = item.getKey) === null || _a === void 0 ? void 0 : _a.call(item),
                                title: (_b = item.getTitle) === null || _b === void 0 ? void 0 : _b.call(item),
                                color: (_c = item.getColor) === null || _c === void 0 ? void 0 : _c.call(item),
                                description: (_d = item.getDescription) === null || _d === void 0 ? void 0 : _d.call(item),
                                percent: (_f = item.getPercent) === null || _f === void 0 ? void 0 : _f.call(item)
                            });
                        };
                        const aspectBreakdown = (((_c = response.getAspectBreakdownList) === null || _c === void 0 ? void 0 : _c.call(response)) || []).map(mapItem);
                        const slopeBreakdown = (((_d = response.getSlopeBreakdownList) === null || _d === void 0 ? void 0 : _d.call(response)) || []).map(mapItem);
                        const elevationBreakdown = (((_f = response.getElevationBreakdownList) === null || _f === void 0 ? void 0 : _f.call(response)) || []).map(mapItem);
                        const geomorphonsBreakdown = (((_g = response.getGeomorphonsBreakdownList) === null || _g === void 0 ? void 0 : _g.call(response)) || []).map(mapItem);
                        const normalizeNum = (n) => (typeof n === 'number' && n !== 0 ? n : undefined);
                        const maxHeightM = normalizeNum((_h = response.getMaxHeightM) === null || _h === void 0 ? void 0 : _h.call(response));
                        const minHeightM = normalizeNum((_j = response.getMinHeightM) === null || _j === void 0 ? void 0 : _j.call(response));
                        const altitudeStdDev = normalizeNum((_k = response.getAltitudeStdDev) === null || _k === void 0 ? void 0 : _k.call(response));
                        const name = ((_l = response.getName) === null || _l === void 0 ? void 0 : _l.call(response)) || undefined;
                        const description = ((_m = response.getDescription) === null || _m === void 0 ? void 0 : _m.call(response)) || undefined;
                        const hemisphere = ((_o = response.getHemisphere) === null || _o === void 0 ? void 0 : _o.call(response)) || undefined;
                        const stats = {
                            name,
                            description,
                            hemisphere,
                            propertyPolygon: propertyPolygon.length >= 3 ? propertyPolygon : undefined,
                            bufferPolygon: bufferPolygon.length >= 3 ? bufferPolygon : undefined,
                            maxHeightM,
                            minHeightM,
                            altitudeStdDev,
                            aspectBreakdown: aspectBreakdown.length > 0 ? aspectBreakdown : undefined,
                            slopeBreakdown: slopeBreakdown.length > 0 ? slopeBreakdown : undefined,
                            elevationBreakdown: elevationBreakdown.length > 0 ? elevationBreakdown : undefined,
                            geomorphonsBreakdown: geomorphonsBreakdown.length > 0 ? geomorphonsBreakdown : undefined
                        };
                        resolve(stats);
                    }
                    catch (_mapErr) {
                        resolve(null);
                    }
                });
            }
            catch (_e) {
                resolve(null);
            }
        });
    }
}
export const statisticsService = new StatisticsService();
